export const ENV_JSON = 'environment/environment.json';
